
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import MesaData from "./MesaData";

export default {
  name: "app-restaurante-mesas-update",
  data() {
    return {
      mesa: new MesaData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getMesa(id) {
      try {
        const { data } = await this.$http.post("/restaurante/mesas/find", {
          id: id,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        this.setLoading(true);
        const mesa = await this.getMesa(id);
        this.setLoading(false);

        if (!mesa || !mesa.id) {
          this.$router.push(this.voltarRoute);
          return this.$toast.error("Mesa não encontrada!");
        }

        this.mesa = new MesaData(mesa);
      } catch {
        this.setLoading(false);
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    routeAmbienteId() {
      return this.$route.query.ambiente_id || this.$route.params.ambienteId;
    },
    voltarRoute() {
      if (!this.routeAmbienteId) {
        return { name: "restauranteMesasCadastro" };
      }

      return {
        name: "restauranteAmbientesMesas",
        params: {
          ambienteId: this.routeAmbienteId,
        },
        query: {
          ambiente_nome: this.$route.query.ambiente_nome,
        },
      };
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
